"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;

var _react = _interopRequireDefault(require("react"));

var _LazyImage = require("../Image/LazyImage");

var _Avatar = require("./Avatar.shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** An circular Avatar component containing an image or initials */
var Avatar = function Avatar(_ref) {
  var src = _ref.src,
      initials = _ref.initials,
      _ref$lazyLoad = _ref.lazyLoad,
      lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size;

  var _sizeValue = (0, _Avatar.sizeValue)(size),
      diameter = _sizeValue.diameter;

  return _react.default.createElement(_Avatar.BaseAvatar, {
    src: src,
    initials: initials,
    size: size,
    renderAvatar: function renderAvatar() {
      return _react.default.createElement(_LazyImage.LazyImage, {
        preload: !lazyLoad,
        width: diameter,
        height: diameter,
        borderRadius: diameter,
        src: src
      });
    }
  });
};

exports.Avatar = Avatar;
Avatar.displayName = "Avatar";
//# sourceMappingURL=Avatar.js.map